__webpack_require__.p = "/Travel-Journal/";